import React from 'react';
import CommissionRateItem from '../Domain/CommissionRateItem';
import AuthService from './authService';
import OpportunityCommissionRateItem from '../Domain/OpportunityCommissionRateItem';
import CommissionRateOverrideItem from '../Domain/CommissionRateOverrideItem';
import SearchParams from '../Elements/SearchParams';
import CommissionRateSearchParams from '../Contents/User/CommissionRate/CommissionRateSearchParams';

export default class CommissionRateService extends React.Component {
  static GetListBySearching(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    const searchParams = new SearchParams(searchItem, CommissionRateSearchParams, orderById, orderDir, pageNumber, numberOfElements);
    return AuthService.getInstance().CallBackendFunction(
      `/api/CommissionRate/GetListBySearchingAsync?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`
    );
  }

  static ConvertDBItems(items) {
    const convertedItems = [];
    if (items !== null) {
      items.forEach((item) => {
        const newItem = new CommissionRateItem(item);
        convertedItems.push(newItem);
      });
    }

    return convertedItems;
  }

  static ConvertOverrideDBItems(items) {
    const convertedItems = [];
    if (items !== null) {
      items.forEach((item) => {
        const newItem = new CommissionRateOverrideItem(item);
        convertedItems.push(newItem);
      });
    }

    return convertedItems;
  }

  static GetListBySearchingForOpportunity(
    orderById,
    orderDir,
    pageNumber,
    numberOfElements,
    searchItem,
    clearCache = false
  ) {
    const searchParams = new SearchParams(searchItem, CommissionRateSearchParams, orderById, orderDir, pageNumber, numberOfElements);
    return AuthService.getInstance().CallBackendFunction(
      `/api/CommissionRate/GetListBySearchingForOpportunityAsync?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`
    );
  }

  static ConvertForOpportunityDBItems(items) {
    const convertedItems = [];
    if (items !== null) {
      items.forEach((item) => {
        const newItem = new OpportunityCommissionRateItem(item);
        convertedItems.push(newItem);
      });
    }

    return convertedItems;
  }

  static UpsertItem(item) {
    const url = `/api/CommissionRate/UpsertAsync`;
    const commissionRateJson = JSON.stringify(item);
    return AuthService.getInstance().CallBackendFunctionPost(url, commissionRateJson);
  }

  static CloseItem(item) {
    const url = `/api/CommissionRate/CloseAsync`;
    const commissionRateJson = JSON.stringify(item);
    return AuthService.getInstance().CallBackendFunctionPut(url, commissionRateJson);
  }

  static ChangeStatus(item) {
    const url = `/api/CommissionRate/ChangeStatusAsync`;
    const commissionRateJson = JSON.stringify(item);
    return AuthService.getInstance().CallBackendFunctionPut(url, commissionRateJson);
  }
}
